import React,{useState,useEffect} from 'react';
import Axios from 'axios';
import NoteTile from './NoteTile';
import EditNoteModal from './EditNoteModal';
import AlimLoader from '../ui-elements/AlimLoader';
import EmptyMessage from '../ui-elements/EmptyMessage';
import LoaderCircle from '../ui-elements/LoaderCircle';

const AlimNotes=({webToken,alimUserID,noteCat,noteRefer, noteSection, isNotesModal})=>{
    const [notesData,setNotesData]=useState(["empty"]);
    const [isEditModalOpen,setIsEditModalOpen]=useState(false);
    const [noteID,setNoteID]=useState("");
    const [noteTitle,setNoteTitle]=useState("");
    const [noteContent,setNoteContent]=useState("");
    const [nextPage,setNextPage]=useState(1);
    const [isNotesLoading,setIsNotesLoading]=useState(false);
    const [isLastPage,setIsLastPage]=useState(false);
    const [totalCount,setTotalCount]=useState(0);

    const fetchNotes=(pageNo,pageSize=10)=>{
        setIsNotesLoading(true);
        if(noteCat)
        {
            Axios.post(`${alimAPIBaseURI}rpc/get_all_notes_by_user_cat`, {cat:noteCat,note_ref:noteRefer,page_number:pageNo,page_size:pageSize},{headers: {"Content-Type": "application/json","Authorization":`bearer ${webToken}`}}).then((data)=>{
                setTotalCount(data.data[0].total_count);
                if(notesData[0]==="empty"||pageNo===1)
                {
                    setNotesData(data.data[0].notes);
                }
                else
                {
                    setNotesData([...notesData,...data.data[0].notes]);
                }
                setNextPage(pageNo+1);
                setIsNotesLoading(false);
            }).catch((error)=>{
                console.log(error);
                setIsNotesLoading(false);
            });
        }
        else
        {
            Axios.post(`${alimAPIBaseURI}rpc/get_all_notes_by_user`, {page_number:pageNo,page_size:pageSize},{headers: {"Content-Type": "application/json","Authorization":`bearer ${webToken}`}}).then((data)=>{
                setTotalCount(data.data[0].total_count);
                if(notesData[0]==="empty"||pageNo===1)
                {
                    setNotesData(data.data[0].notes)
                }
                else
                {
                    setNotesData([...notesData,...data.data[0].notes]);
                }
                setNextPage(pageNo+1);
                setIsNotesLoading(false);
            }).catch((error)=>{
                console.log(error);
                setIsNotesLoading(false);
            });
        }
    }

    const timeAgo=(input)=>{
        const date = (input instanceof Date) ? input : new Date(input);
        const formatter = new Intl.RelativeTimeFormat('en');
        const ranges = {
            years: 3600 * 24 * 365,
            months: 3600 * 24 * 30,
            weeks: 3600 * 24 * 7,
            days: 3600 * 24,
            hours: 3600,
            minutes: 60,
            seconds: 1
        };
        const secondsElapsed = (date.getTime() - Date.now()) / 1000;
        for (let key in ranges) {
            if (ranges[key] < Math.abs(secondsElapsed)) {
                const delta = secondsElapsed / ranges[key];
                return formatter.format(Math.round(delta), key);
            }
        }
    }

    const showEditModal=(id,title,content)=>{
        setNoteID(id);
        setNoteTitle(title);
        setNoteContent(content);
        setIsEditModalOpen(!isEditModalOpen);
    }

    useEffect(()=>{
        const tafsirEventHandler=()=>{
            fetchNotes(1);
        }
        document.addEventListener("tafsir-notes",tafsirEventHandler);

        return()=>{
            document.removeEventListener("tafsir-notes", tafsirEventHandler);
        }
    });

    useEffect(()=>{
        if(notesData.length>=totalCount)
        {
            setIsLastPage(true);
        }
        else
        {
            setIsLastPage(false);
        }
    },[notesData,isEditModalOpen]);

    useEffect(()=>{
        fetchNotes(nextPage);
    },[]);

    if(notesData.length>0&&notesData[0]!=="empty")
    {
        return(
            <div className='grid grid-cols-12 gap-6 w-full'>
                {/* {noteCat?null:<h2 className='col-span-12'>Your Notes</h2>} */}
                {
                    notesData.map((note,noteIndex)=>{
                        if(noteCat)
                        {
                            return(
                                <NoteTile key={noteIndex} noteId={note.note_id} noteTitle={note.title} noteContent={note.content} noteTime={timeAgo(new Date(Number(note.note_time)))} modalFunc={showEditModal} webToken={webToken} noteFetchFunc={fetchNotes} isNotesModal={isNotesModal}/>
                            )
                        }
                        else
                        {
                            return(
                                <NoteTile key={noteIndex} noteId={note.note_id} noteTitle={note.title} noteContent={note.content} noteTime={timeAgo(new Date(Number(note.note_time)))} modalFunc={showEditModal} noteType={note.type} noteTopic={note.note_reference} webToken={webToken} noteFetchFunc={fetchNotes}/>
                            )
                        }
                    })
                }

                {
                    !isLastPage?
                    <>
                        {notesData.length>=10&&!isNotesLoading&&
                            <div className='col-span-12 flex justify-center pt-6' onClick={()=>{fetchNotes(nextPage)}}>
                                <button className="bg-deep-red px-5 py-2 rounded-md text-white">
                                    Load more
                                </button>
                            </div>
                            
                        }
        
                        {notesData.length>=10&&isNotesLoading&&
                            <div className='col-span-12 flex justify-center pt-6'>
                                <LoaderCircle/>
                            </div>
                        }
                    </>
                    :
                    null
                }

                {isEditModalOpen&&<EditNoteModal webToken={webToken} noteId={noteID} noteTitle={noteTitle} noteContent={noteContent} modalFunc={setIsEditModalOpen} refreshFunc={fetchNotes} isNotesModal={isNotesModal}/>}
            </div>
        )
    }
    else if(notesData.length>0&&notesData[0]==="empty")
    {
        return(
            <div>
                <AlimLoader loaderMsg={"Loading Notes."}/>
            </div>
            
        )
    }
    else
    {
        return(
            <EmptyMessage msgTitle={noteCat?"":"Your notes"} msgData={"No notes posted !"} noteSection={noteSection}/>
        );
    }
}

export default AlimNotes;